(function() { module.exports = this["wp"]["components"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","components"]}
// module id = 62
// module chunks = 0 1